"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GAME_TYPE = void 0;
var GAME_TYPE = Object.freeze({
  EXPRESS: 'express',
  REGULAR: 'regular',
  SINGLE_PLAY_CHAMP: 'singleplay champ',
  SINGLE_PLAY_LEARN: 'singleplay learn'
});
exports.GAME_TYPE = GAME_TYPE;